import Card from '@/components/Card';
import Page from '@/components/Page';
import Stack from '@/components/Stack';
import { Body, Heading } from '@/components/Typography';

// Vexo dashboard URL — leaving as the public marketing site for now since
// the tenant-specific dashboard URL (and how to authenticate to it) is one
// of the pre-rollout open questions for Vexo support.
const VEXO_DASHBOARD_URL = 'https://www.vexo.co/';

const Analytics = () => {
  const isProduction = process.env.NODE_ENV === 'production';
  const sdkLoaded =
    typeof window !== 'undefined' &&
    !!(window as Window & { vexo?: unknown }).vexo;

  return (
    <Page title="Analytics">
      <Stack vertical gap="20px">
        <Card>
          <Stack vertical gap="12px">
            <Heading>Vexo Analytics</Heading>
            <Body>
              Session recordings, heatmaps, and custom events are captured
              automatically on every environment that has a Vexo project key.
            </Body>

            <Body>
              <strong>Environment:</strong>{' '}
              {isProduction ? 'production' : 'non-production (SDK skipped)'}
            </Body>
            <Body>
              <strong>SDK loaded on this tab:</strong>{' '}
              {sdkLoaded ? 'yes' : 'no'}
            </Body>
          </Stack>
        </Card>

        <Card>
          <Stack vertical gap="8px">
            <Heading>Operator notes</Heading>
            <Body>
              <strong>Kill switch:</strong> set{' '}
              <code>
                localStorage[&apos;vexo:disabled&apos;] = &apos;1&apos;
              </code>{' '}
              and reload to disable the SDK in that browser. There is no longer
              a fleet-wide switch — the GrowthBook flag and the{' '}
              <code>DISABLE_VEXO</code> build variable were removed, so turning
              Vexo off everywhere means a deploy.
            </Body>
            <Body>
              <strong>Dashboard:</strong>{' '}
              <a
                href={VEXO_DASHBOARD_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open Vexo dashboard ↗
              </a>
            </Body>
          </Stack>
        </Card>
      </Stack>
    </Page>
  );
};

export default Analytics;
